/* MANHAUS v3 — interacción (vanilla JS) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;

  function listo() {
    html.classList.add('mh-listo');
    document.dispatchEvent(new CustomEvent('mh:listo'));
  }

  /* ---------- Intro con video ---------- */
  function initIntro() {
    var intro = document.querySelector('[data-mh-intro]');
    if (!intro || !html.classList.contains('mh-con-intro')) { listo(); return; }
    var video = intro.querySelector('video');
    var saltar = intro.querySelector('[data-mh-intro-saltar]');
    var cerrado = false;
    function cerrar(ev) {
      if (cerrado) return; cerrado = true;
      try { sessionStorage.setItem('mh-intro', '1'); } catch (e) {}
      intro.classList.add('mh-saliendo');
      html.classList.remove('mh-sin-scroll');
      setTimeout(function () { html.classList.remove('mh-con-intro'); intro.remove(); }, 1100);
      setTimeout(listo, 350);
    }
    saltar.addEventListener('click', cerrar);
    intro.addEventListener('click', cerrar);
    window.addEventListener('wheel', cerrar, { once: true, passive: true });
    window.addEventListener('touchmove', cerrar, { once: true, passive: true });
    window.addEventListener('keydown', cerrar, { once: true });
    video.playbackRate = 1.5;
    video.addEventListener('timeupdate', function () {
      if (video.duration) intro.style.setProperty('--mh-intro', (video.currentTime / video.duration).toFixed(3));
    });
    video.addEventListener('ended', function () { setTimeout(cerrar, 350); });
    video.muted = true;
    var intentos = 0;
    function reproducir() {
      var p = video.play();
      if (p && p.catch) p.catch(function (err) {
        // AbortError = el navegador interrumpió la carga: reintentamos; otro error = sin reproducción automática
        if (err && err.name === 'AbortError' && intentos++ < 4) setTimeout(reproducir, 350);
        else cerrar(err);
      });
    }
    reproducir();
    video.addEventListener('pause', function () { if (!cerrado && !video.ended) setTimeout(reproducir, 300); });
    setTimeout(cerrar, 9000); // por si el video no carga
  }

  /* ---------- Barra de progreso ---------- */
  function initProgreso() {
    var ticking = false;
    function upd() {
      var max = document.documentElement.scrollHeight - innerHeight;
      html.style.setProperty('--mh-scroll', max > 0 ? (scrollY / max).toFixed(4) : 0);
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Cursor propio ---------- */
  function initCursor() {
    var c = document.querySelector('.mh-cursor');
    if (!c || !fino || reduce) return;
    var x = -100, y = -100, ax = -100, ay = -100;
    var label = c.querySelector('em');
    addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; c.style.setProperty('--x', x + 'px'); c.style.setProperty('--y', y + 'px'); }, { passive: true });
    (function loop() {
      ax += (x - ax) * 0.18; ay += (y - ay) * 0.18;
      c.style.setProperty('--ax', ax.toFixed(1) + 'px'); c.style.setProperty('--ay', ay.toFixed(1) + 'px');
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      var ver = e.target.closest('[data-mh-cursor], .mh-card, .mh-vitrina__card, .mh-pdp__slide');
      var link = e.target.closest('a, button, label, summary, input[type=range]');
      c.classList.toggle('mh-cursor--ver', !!ver);
      c.classList.toggle('mh-cursor--link', !ver && !!link);
      if (ver) label.textContent = ver.getAttribute('data-mh-cursor') || (ver.classList.contains('mh-pdp__slide') ? 'Zoom' : 'Ver');
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagneticos(root) {
    if (!fino || reduce) return;
    (root || document).querySelectorAll('.mh-btn:not([data-mh-mag])').forEach(function (b) {
      b.setAttribute('data-mh-mag', '');
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        b.style.transform = 'translate(' + (dx * 0.18).toFixed(1) + 'px,' + (dy * 0.3).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Brillo en tarjetas ---------- */
  function initGlare() {
    if (!fino || reduce) return;
    document.addEventListener('mousemove', function (e) {
      var m = e.target.closest && e.target.closest('.mh-card__media');
      if (!m) return;
      var r = m.getBoundingClientRect();
      m.style.setProperty('--gx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      m.style.setProperty('--gy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* ---------- Títulos palabra por palabra ---------- */
  function partir(el) {
    var i = 0;
    function recorrer(nodo) {
      [].slice.call(nodo.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var partes = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          partes.forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
            var o = document.createElement('span'); o.className = 'mh-p';
            var s = document.createElement('span'); s.textContent = t; s.style.setProperty('--w', i++);
            o.appendChild(s); frag.appendChild(o);
          });
          nodo.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { recorrer(n); }
      });
    }
    recorrer(el);
  }
  function initSplit(root) {
    if (reduce) return;
    (root || document).querySelectorAll('.mh-h2:not([data-mh-split]), [data-mh-split-auto]:not([data-mh-split])').forEach(function (h) {
      if (h.closest('.mh-medidor')) return;
      h.setAttribute('data-mh-split', '');
      partir(h);
      h.classList.add('mh-split');
      if (!h.classList.contains('mh-reveal')) h.classList.add('mh-reveal');
    });
    // reutiliza el observador de mh-scripts.js si ya corrió: observamos los nuevos
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mh-visible'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      (root || document).querySelectorAll('.mh-split:not(.mh-visible), .mh-cortina:not(.mh-visible)').forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- Medidor de tallas ---------- */
  var TALLAS = [ [8, 18.2], [9, 19.0], [10, 19.8], [11, 20.6] ];
  function tallaPorDiametro(d) {
    var mejor = TALLAS[0], dif = 99;
    TALLAS.forEach(function (t) { var x = Math.abs(t[1] - d); if (x < dif) { dif = x; mejor = t; } });
    if (d < 17.4) return 'Menor a talla 8';
    if (d > 21.4) return 'Mayor a talla 11';
    return 'Talla ' + mejor[0];
  }
  function initMedidor() {
    var modal = document.querySelector('[data-mh-medidor-modal]');
    if (!modal) return;
    var pxmm = null;
    try { pxmm = parseFloat(localStorage.getItem('mh-pxmm')) || null; } catch (e) {}
    var tarjeta = modal.querySelector('[data-mh-tarjeta]'), tR = modal.querySelector('[data-mh-tarjeta-rango]');
    var circulo = modal.querySelector('[data-mh-circulo]'), cR = modal.querySelector('[data-mh-circulo-rango]');
    var calibrar = modal.querySelector('[data-mh-calibrar]'), medir = modal.querySelector('[data-mh-medir]');
    function pintarTarjeta() { tarjeta.style.setProperty('--tw', tR.value + 'px'); }
    function pintarCirculo() {
      var d = parseFloat(cR.value);
      circulo.style.setProperty('--cd', (d * (pxmm || 3.77)).toFixed(1) + 'px');
      modal.querySelector('[data-mh-mm]').textContent = d.toFixed(1) + ' mm';
      modal.querySelector('[data-mh-talla]').textContent = tallaPorDiametro(d);
    }
    function paso(calibrado) { calibrar.hidden = calibrado; medir.hidden = !calibrado; if (calibrado) pintarCirculo(); }
    tR.addEventListener('input', pintarTarjeta);
    cR.addEventListener('input', pintarCirculo);
    modal.querySelector('[data-mh-calibrado]').addEventListener('click', function () {
      pxmm = parseFloat(tR.value) / 85.6;
      try { localStorage.setItem('mh-pxmm', pxmm); } catch (e) {}
      paso(true);
    });
    modal.querySelector('[data-mh-recalibrar]').addEventListener('click', function () { paso(false); });
    modal.querySelectorAll('[data-mh-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        modal.querySelectorAll('[data-mh-tab]').forEach(function (x) { x.classList.toggle('mh-activo', x === t); });
        modal.querySelectorAll('[data-mh-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-mh-panel') !== t.getAttribute('data-mh-tab'); });
      });
    });
    modal.querySelector('[data-mh-contorno]').addEventListener('input', function (e) {
      var c = parseFloat(e.target.value);
      if (!c) return;
      var d = c / Math.PI;
      modal.querySelector('[data-mh-mm2]').textContent = d.toFixed(1) + ' mm de diámetro';
      modal.querySelector('[data-mh-talla2]').textContent = tallaPorDiametro(d);
    });
    function abrir(e) { if (e) e.preventDefault(); modal.hidden = false; html.classList.add('mh-sin-scroll'); pintarTarjeta(); paso(!!pxmm); }
    function cerrar() { modal.hidden = true; html.classList.remove('mh-sin-scroll'); }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mh-medidor]');
      if (a) abrir(e);
      if (e.target.closest('[data-mh-medidor-cerrar]')) cerrar();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cerrar(); });
  }

  /* ---------- Hero: seguimiento del mouse ---------- */
  function initHero() {
    document.querySelectorAll('[data-mh-hero2]').forEach(function (h) {
      if (reduce) return;
      var capas = [].slice.call(h.querySelectorAll('[data-mh-prof]'));
      h.addEventListener('mousemove', function (e) {
        var r = h.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        h.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        h.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
        capas.forEach(function (c) {
          var k = parseFloat(c.getAttribute('data-mh-prof')) || 10;
          c.style.transform = 'translate3d(' + (x * k).toFixed(1) + 'px,' + (y * k).toFixed(1) + 'px,0)';
        });
      });
      // rotación automática de la pieza destacada
      var fotos = [].slice.call(h.querySelectorAll('.mh-hero2__foto'));
      if (fotos.length > 1) {
        var i = 0;
        setInterval(function () {
          fotos[i].classList.remove('mh-frente');
          i = (i + 1) % fotos.length;
          fotos[i].classList.add('mh-frente');
        }, 3200);
      }
    });
  }

  /* ---------- Vitrina horizontal ---------- */
  function initVitrina() {
    document.querySelectorAll('[data-mh-vitrina]').forEach(function (v) {
      var pista = v.querySelector('[data-mh-vitrina-pista]');
      var num = v.querySelector('[data-mh-vitrina-num]');
      var cards = v.querySelectorAll('.mh-vitrina__card');
      if (!pista) return;
      function modoSticky() { return window.innerWidth > 989 && !reduce; }
      function medir() {
        if (!modoSticky()) { v.style.height = ''; pista.style.transform = ''; return; }
        var extra = pista.scrollWidth - window.innerWidth + 120;
        v.style.height = (window.innerHeight + Math.max(extra, 0)) + 'px';
      }
      var ticking = false;
      function upd() {
        ticking = false;
        if (!modoSticky()) return;
        var r = v.getBoundingClientRect();
        var total = v.offsetHeight - window.innerHeight;
        var p = Math.min(Math.max(-r.top / (total || 1), 0), 1);
        var extra = pista.scrollWidth - window.innerWidth + 120;
        pista.style.transform = 'translate3d(' + (-p * Math.max(extra, 0)).toFixed(1) + 'px,0,0)';
        v.style.setProperty('--vp', p.toFixed(3));
        if (num && cards.length) num.textContent = String(Math.min(cards.length, Math.floor(p * cards.length) + 1)).padStart(2, '0');
      }
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      addEventListener('resize', function () { medir(); upd(); });
      addEventListener('load', function () { medir(); upd(); });
      medir(); upd();
    });
  }

  /* ---------- Armá tu dúo ---------- */
  function dinero(c, f) {
    var n = c / 100, dec = Math.round(c) % 100 === 0 ? 0 : 2;
    var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (f || '₡{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, p.join(','));
  }
  function initDuo() {
    document.querySelectorAll('[data-mh-duo]').forEach(function (d) {
      var datos = JSON.parse(d.querySelector('[data-mh-duo-datos]').textContent);
      var elegidos = []; // {pid, vid, titulo, img, precio}
      var boton = d.querySelector('[data-mh-duo-agregar]');
      var slots = d.querySelectorAll('[data-mh-duo-slot]');
      var antes = d.querySelector('[data-mh-duo-antes]');
      var barra = d.querySelector('[data-mh-duo-barra]');
      var aviso = d.querySelector('[data-mh-duo-aviso]');
      function pintar() {
        slots.forEach(function (s, i) {
          var e = elegidos[i];
          s.classList.toggle('mh-lleno', !!e);
          s.innerHTML = e ? '<img src="' + e.img + '" alt=""><span>' + e.titulo + '<small>Talla ' + e.talla + '</small></span>' : '<span class="mh-duo__vacio">' + (i + 1) + '</span>';
        });
        d.querySelectorAll('[data-mh-duo-item]').forEach(function (it) {
          var sel = elegidos.some(function (e) { return e.pid === it.getAttribute('data-mh-duo-item'); });
          it.classList.toggle('mh-elegido', sel);
          var b = it.querySelector('[data-mh-duo-elegir]'); if (b) b.textContent = sel ? 'Quitar' : 'Elegir';
        });
        var suma = elegidos.reduce(function (a, e) { return a + e.precio; }, 0);
        if (antes) antes.textContent = elegidos.length === 2 ? dinero(suma, datos.moneda) : dinero(datos.precioBase * 2, datos.moneda);
        if (barra) barra.style.setProperty('--dp', elegidos.length / 2);
        boton.disabled = elegidos.length < 2;
        boton.querySelector('span').textContent = elegidos.length < 2 ? ('Elegí ' + (2 - elegidos.length) + ' más') : datos.textoListo;
      }
      d.querySelectorAll('[data-mh-duo-item]').forEach(function (it) {
        var pid = it.getAttribute('data-mh-duo-item');
        var select = it.querySelector('select');
        it.querySelector('[data-mh-duo-elegir]').addEventListener('click', function () {
          var idx = elegidos.findIndex(function (e) { return e.pid === pid; });
          if (idx > -1) { elegidos.splice(idx, 1); pintar(); return; }
          if (elegidos.length >= 2) { if (aviso) { aviso.hidden = false; setTimeout(function () { aviso.hidden = true; }, 2200); } return; }
          var opt = select.options[select.selectedIndex];
          elegidos.push({ pid: pid, vid: select.value, talla: opt.text, titulo: it.getAttribute('data-titulo'), img: it.getAttribute('data-img'), precio: parseInt(opt.getAttribute('data-precio'), 10) });
          pintar();
        });
        select.addEventListener('change', function () {
          var e = elegidos.find(function (x) { return x.pid === pid; });
          if (e) { var opt = select.options[select.selectedIndex]; e.vid = select.value; e.talla = opt.text; pintar(); }
        });
      });
      boton.addEventListener('click', function () {
        if (elegidos.length < 2) return;
        boton.classList.add('mh-cargando');
        var drawer = document.querySelector('cart-drawer');
        var body = { items: elegidos.map(function (e) { return { id: parseInt(e.vid, 10), quantity: 1 }; }) };
        if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description);
            if (datos.destino === 'checkout') { location.href = '/checkout'; return; }
            if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
            else location.href = '/cart';
            elegidos = []; pintar();
          })
          .catch(function () { location.href = '/cart'; })
          .finally(function () { boton.classList.remove('mh-cargando'); });
      });
      pintar();
    });
  }

  /* ---------- Compra rápida: talla en la tarjeta → carrito ---------- */
  function initRapido() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mh-rapido]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      var previo = b.innerHTML;
      b.classList.add('mh-cargando');
      var body = { items: [{ id: parseInt(b.getAttribute('data-mh-rapido'), 10), quantity: 1 }] };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description);
          b.classList.remove('mh-cargando'); b.classList.add('mh-ok'); b.innerHTML = '✓';
          setTimeout(function () { b.classList.remove('mh-ok'); b.innerHTML = previo; }, 1600);
          if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else location.href = '/cart';
        })
        .catch(function () { b.classList.remove('mh-cargando'); b.innerHTML = previo; location.href = '/cart'; });
    });
  }

  /* ---------- Filtros por acabado ---------- */
  function initFiltros(root) {
    (root || document).querySelectorAll('[data-mh-filtros]:not([data-mh-listo])').forEach(function (f) {
      f.setAttribute('data-mh-listo', '');
      var cards = [].slice.call(f.parentElement.querySelectorAll('.mh-grid > .mh-card'));
      f.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mh-filtro]');
        if (!b) return;
        var v = b.getAttribute('data-mh-filtro');
        f.querySelectorAll('[data-mh-filtro]').forEach(function (x) { x.classList.toggle('mh-activo', x === b); });
        cards.forEach(function (c, i) {
          var ok = v === 'todos' || (' ' + (c.getAttribute('data-mh-acabado') || '') + ' ').indexOf(' ' + v + ' ') > -1;
          c.classList.toggle('mh-oculta', !ok);
          c.classList.remove('mh-entra');
          if (ok) { void c.offsetWidth; c.style.animationDelay = (i % 8) * 40 + 'ms'; c.classList.add('mh-entra', 'mh-visible'); }
        });
      });
    });
  }

  function initTodo(root) { initSplit(root); initMagneticos(root); initFiltros(root); }

  document.addEventListener('DOMContentLoaded', function () {
    initIntro(); initProgreso(); initCursor(); initGlare(); initMedidor(); initHero(); initVitrina(); initDuo(); initRapido();
    initTodo(document);
  });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); initHero(); initVitrina(); initDuo(); });
})();
